// src\components\LlmProcessingCard\LlmFlowDiagram\LlmFlowBlocks.js
import React from "react";
import { Box, Paper, Stack, Typography, Chip } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

function LlmFlowBlocks({
  blocks,
  selectedBlockId,
  selectedSubunitId,
  onSelectBlock,
  onSelectSubunit,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflowX: { md: "auto" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 1, md: 1.5 },
          mb: 2,
        }}
      >
        {blocks.map((block, index) => {
          const isSelected = block.id === selectedBlockId;
          const showSubunits = block.subunits && block.subunits.length > 0;

          return (
            <React.Fragment key={block.id}>
              {/* Block card */}
              <Paper
                variant="outlined"
                onClick={
                  block.clickable
                    ? () => onSelectBlock(block.id)
                    : undefined
                }
                sx={{
                  minWidth: { xs: "auto", md: 100 },
                  maxWidth: { xs: "100%", md: 160 },
                  width: { xs: "100%", md: "auto" },
                  flex: { md: "1 1 0" },
                  cursor: block.clickable ? "pointer" : "default",
                  borderRadius: 2,
                  px: 1.25,
                  py: 1,
                  textAlign: "center",
                  bgcolor: isSelected ? "grey.100" : "grey.50",
                  borderColor: isSelected ? "primary.main" : "grey.300",
                  boxShadow: isSelected
                    ? "0 0 0 1px rgba(25,118,210,0.5)"
                    : "none",
                }}
              >
                <Stack spacing={0.5} alignItems="center">
                  {block.icon}
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: block.phase === "ai" ? 700 : 500,
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      fontSize: { xs: "0.7rem", md: "0.72rem" },
                      color:
                        block.phase === "ai"
                          ? "primary.main"
                          : "text.secondary",
                      wordBreak: "break-word",
                    }}
                  >
                    {block.label}
                  </Typography>

                  {/* Optional subunits as chips inside the block */}
                  {showSubunits && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.75,
                        mt: 1,
                        width: "100%",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {block.subunits.map((sub) => {
                        const isSubSelected =
                          isSelected && selectedSubunitId === sub.id;
                        return (
                          <Chip
                            key={sub.id}
                            label={sub.label}
                            size="small"
                            variant={isSubSelected ? "filled" : "outlined"}
                            color={isSubSelected ? "primary" : "default"}
                            onClick={() => onSelectSubunit(block.id, sub.id)}
                            sx={{
                              borderRadius: 999,
                              width: "100%",
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}
                </Stack>
              </Paper>

              {/* Arrow between blocks */}
              {index < blocks.length - 1 && (
                <>
                  {/* Horizontal arrow for md+ */}
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <ArrowForwardIcon sx={{ color: "text.disabled", fontSize: 20 }} />
                  </Box>
                  {/* Vertical arrow for mobile */}
                  <Box
                    sx={{
                      display: { xs: "flex", md: "none" },
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ArrowDownwardIcon sx={{ color: "text.disabled", fontSize: 20 }} />
                  </Box>
                </>
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
}

export default LlmFlowBlocks;
